import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiFetch('/login', {
        method: 'POST',
        body: JSON.stringify({ email, password })
      });

      localStorage.setItem('token', response.access_token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    if (googleLoading) return; // Prevent multiple clicks
    
    setError('');
    setGoogleLoading(true);

    try {
      // Get Google OAuth URL
      const response = await apiFetch('/auth/google/url');
      
      // Clear any existing tokens to prevent conflicts
      localStorage.removeItem('token');
      localStorage.removeItem('google_user');
      
      // Redirect to Google OAuth
      window.location.href = response.auth_url;
    } catch (err) {
      setError(`Google sign-in failed: ${err.message}`);
      setGoogleLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      gap: '20px',
      flexWrap: 'wrap'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px',
        flex: '0 1 400px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>
          Sign In to EduAI
        </h2>

        {error && (
          <div style={{
            background: '#fee',
            color: '#c33',
            padding: '15px',
            borderRadius: '6px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', color: '#555' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', color: '#555' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: loading ? '#ccc' : '#4f8cff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer',
              marginBottom: '15px'
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <span style={{ color: '#666' }}>or</span>
        </div>

        <button
          onClick={handleGoogleSignIn}
          disabled={googleLoading}
          style={{
            width: '100%',
            padding: '12px',
            background: googleLoading ? '#ccc' : '#db4437',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: googleLoading ? 'not-allowed' : 'pointer',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}
        >
          {googleLoading ? (
            <>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #fff',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              Connecting...
            </>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google
            </>
          )}
        </button>

        <div style={{ textAlign: 'center' }}>
          <span style={{ color: '#666' }}>Don't have an account? </span>
          <button
            onClick={() => navigate('/register')}
            style={{
              background: 'none',
              border: 'none',
              color: '#4f8cff',
              cursor: 'pointer',
              fontSize: '14px',
              textDecoration: 'underline'
            }}
          >
            Sign up
          </button>
        </div>
      </div>

      {/* Side Notice Box */}
      <div style={{
        background: 'white',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '380px',
        flex: '0 1 380px',
        border: '2px solid #667eea'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
          <div style={{
            width: '32px',
            height: '32px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px'
          }}>⚡</div>
          <h3 style={{ margin: 0, color: '#667eea', fontSize: '16px', fontWeight: '700' }}>
            Google AI Features
          </h3>
        </div>
        
        <p style={{ margin: '0 0 15px 0', fontSize: '13px', color: '#555', lineHeight: '1.6' }}>
          <strong>No Domain Purchased:</strong> Google only allows whitelisted accounts to sign in. Without a verified domain, only pre-authorized emails can use Google OAuth.
        </p>
        
        <div style={{ background: '#f8f9ff', padding: '12px', borderRadius: '8px', marginBottom: '15px' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '12px', fontWeight: '600', color: '#333' }}>✨ Full AI Features:</p>
          <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '11px', lineHeight: '1.8', color: '#666' }}>
            <li>Drive - Auto-save notes</li>
            <li>Gmail - Smart notifications</li>
            <li>Calendar - Schedule sessions</li>
            <li>YouTube - Curated playlists</li>
            <li>LinkedIn - Share achievements</li>
          </ul>
        </div>
        
        <div style={{ background: '#fff3cd', padding: '12px', borderRadius: '6px', marginBottom: '12px', borderLeft: '3px solid #ffc107' }}>
          <p style={{ margin: '0 0 6px 0', fontSize: '12px', color: '#856404', fontWeight: '600' }}>
            📧 <a href="mailto:abhishetty1506@gmail.com" style={{ color: '#667eea', textDecoration: 'none', fontWeight: '700' }}>abhishetty1506@gmail.com</a>
          </p>
          <p style={{ margin: 0, fontSize: '12px', color: '#856404', fontWeight: '600' }}>
            📱 <a href="tel:+919030633137" style={{ color: '#667eea', textDecoration: 'none', fontWeight: '700' }}>+91 90306 33137</a>
          </p>
        </div>
        
        <p style={{ margin: 0, fontSize: '11px', color: '#28a745', fontWeight: '600' }}>
          ✅ Send your email to get instant access to all Google AI features!
        </p>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @media (max-width: 900px) {
          /* Stack vertically on smaller screens */
        }
      `}</style>
    </div>
  );
};

export default Login; 